import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../Components/Modal/modal.js';
import {
  CANCEL_TEXT,
  STAFF_AUG_STATUS_MASTER,
} from '../../Constants/strings.js';
import './deleteStaffAugStatusMaster.scss';
import alertIcon from '../../Assets/images/svg/alert_icon.svg';

const DeleteDialog = ({
  handleCloseAction,
  selectedItem,
  handleDeleteAction,
  setIsDialogOpen,
  setRows,
  handleSnackbar,
  setIsEdit,
  statusCategory,
}) => {
  const content = STAFF_AUG_STATUS_MASTER;

  const dialogTitle = statusCategory === 'geography'
    ? content.DELETE_STAFF_AUG_DEAL_TYPE_TITLE
    : content.DELETE_STAFF_AUG_STATUS_TITLE_TEXT;

  const dialogMessage = statusCategory === 'geography'
    ? content.DELETE_STAFF_AUG_DEAL_TYPE_MESSAGE
    : content.DELETE_STAFF_AUG_STATUS_MESSAGE;

  return (
    <FormDialog
      open={selectedItem !== null}
      title={dialogTitle}
      PaperProps={{}}
      dialogCss="dialog-message"
      dialogPaperCss="delete-dialog-paper"
      width={360}
      height={205}
      dialogBodycontent={
        <div className="dialog-body-text">
          <div className="dialog-alert-icon">
            <img className="icon-image" src={alertIcon} alt="" />
          </div>
          <div className="dialog-message-text">
            {dialogMessage}
          </div>
        </div>
      }
      button1={CANCEL_TEXT}
      cancelButtonId={'cancel-' + content.DELETE_STAFF_AUG_STATUS_BUTTON_ID}
      button2={content.DELETE.BUTTON_TEXT}
      submitButtonId={content.DELETE_STAFF_AUG_STATUS_BUTTON_ID}
      button2Action={() =>
        handleDeleteAction(
          selectedItem,
          setRows,
          setIsDialogOpen,
          handleSnackbar,
          setIsEdit,
        )
      }
      button1Action={() => handleCloseAction(setIsDialogOpen, setIsEdit)}
    />
  );
};

DeleteDialog.propTypes = {
  handleCloseAction: PropTypes.func.isRequired,
  handleDeleteAction: PropTypes.func.isRequired,
  selectedItem: PropTypes.object.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
  setRows: PropTypes.func.isRequired,
  handleSnackbar: PropTypes.func.isRequired,
  setIsEdit: PropTypes.func.isRequired,
  statusCategory: PropTypes.string.isRequired,
};

export default DeleteDialog;
